import React, { useState } from 'react'
import Classes from './Faq.module.css'
import axios from 'axios';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


export default function Faq() {
    const [expanded, setExpanded] = useState('panel1');
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const faqs = [
        {
            question: "What is privacyBot?",
            answer: "privacyBot is an AI-powered platform designed to help you take control of your online privacy. It tracks, identifies, and removes your personal data from data brokers and other online sources, reducing your digital footprint and minimizing the risk of identity theft or misuse of your info."
        },
        {
            question: "How does privacyBot protect my data?",
            answer: "privacyBot uses secure encryption and privacy-first protocols to keep your data safe. We only collect what’s needed to remove your info from data brokers—never selling or sharing anything. You stay in control at all times."
        },
        {
            question: "Does privacyBot train its AI on user data?",
            answer: "No. privacyBot does not use your personal data to train its AI. Your information stays private and is only used to fulfill your data removal requests securely."
        },
        {
            question: "How long does it take for privacyBot to remove my data?",
            answer: "Most removals start within 24 hours, and results typically appear within 7 to 30 days, depending on the data broker’s response time."
        },
        {
            question: "What plans does privacyBot offer?",
            answer: (
                <>
                    privacyBot offers both monthly and yearly plans, so you can choose the option that best fits your needs. Save more with the yearly plan while enjoying full access to all features.
                </>
            )
        }
    ];

    return (
        <>
            <section id='faq-section' className={Classes.section}>
                <div>
                    <div className={Classes.miniText} > FAQS </div>
                    <h1 className={Classes.subheading}> Frequently Asked <br /> Questions </h1>
                    <p className={Classes.text} >
                        Explore answers to our most frequently asked <br className={Classes.br1} /> questions about AI-powered privacy <br className={Classes.br2} /> and data removal. Need more help? <a href='/contact-us' target='_blank' > <span style={{ color: '#006B32', fontWeight: '600', cursor: 'pointer' }} > Contact us</span></a>.
                    </p>
                </div>

                <div id='questions' className={Classes.faqs}>
                    <div className={Classes.faqsCon}>
                        {faqs.map((faq, index) => (
                            <Accordion
                                key={index}
                                expanded={expanded === `panel${index + 1}`}
                                onChange={handleChange(`panel${index + 1}`)}
                                sx={{
                                    border: '1px solid #80808024',
                                    boxShadow: 'rgb(0 0 0 / 13%) 0px 1px 2px',
                                    marginBottom: '1rem',
                                    borderRadius: '7px !important',
                                    padding: '6px 20px !important',
                                    '&:before': {
                                        display: 'none',
                                    }
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls={`panel${index + 1}bh-content`}
                                    id={`panel${index + 1}bh-header`}
                                    sx={{
                                        minHeight: '32px !important',
                                        margin: '0 !important',
                                        padding: '0px 10px !important',
                                        '&.Mui-expanded': {
                                            margin: '0 !important',
                                            minHeight: '32px !important',
                                            padding: '0px 10px !important',
                                        },
                                        '.MuiAccordionSummary-content': {
                                            margin: '10px 0 !important'
                                        },
                                        '.MuiAccordionDetails-root': {
                                            padding: '8px 12px 16px !important'
                                        },
                                    }}
                                >
                                    <div className={Classes.AccordionHeader}>
                                        <h5>{faq.question}</h5>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails className={Classes.accordinBody}
                                    sx={{
                                        padding: '8px 16px 16px 10px !important',
                                    }}
                                >
                                    <h5 className={Classes.accordionText}>{faq.answer}</h5>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </div>
                </div>

            </section>
        </>
    )
}
